import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'kwo-connect-tag',
	templateUrl: './kwo-connect-tag.component.html',
	styleUrls: ['./kwo-connect-tag.component.scss'],
	standalone: true,
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class KwoConnectTagComponent {

}